/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, available: NonNullable<unknown> }} Sub_Downgrade_Free_Up_StorageInputs */



/**
* | output |
* | --- |
* | "Free up storage ({used} used, {available} available on Starter)" |
*
* @param {Sub_Downgrade_Free_Up_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_free_up_storage = /** @type {((inputs: Sub_Downgrade_Free_Up_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Free_Up_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher freigeben (${i?.used} belegt, ${i?.available} verfügbar bei Starter)`)
	return /** @type {LocalizedString} */ (`Free up storage (${i?.used} used, ${i?.available} available on Starter)`)
});